export default "__VITE_ASSET__6b7ba9f2__"